import React from "react";
import { Quote } from "lucide-react";

const FUTURE = [
  { name: "Sofia · Madrid", text: "More than a walk — a piece of Porto stayed with me." },
  { name: "Olivia · Berlin", text: "It was like meeting an old friend in a new city." },
  { name: "Marina · Buenos Aires", text: "I usually skip tours. This was the opposite — slow and honest." },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials" className="py-24 md:py-32 bg-[#F7F1E8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.28em] text-[#5E7891] mb-5">Voices · Voces</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#2D3640]">A few words from people who walked with us.</h2>
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {FUTURE.map((tt, i) => (
            <figure key={i} data-testid={`testimonial-${i}`}
              className="p-7 rounded-3xl bg-[#FDFAF3] border border-[#E5D9C0] flex flex-col gap-5 relative">
              <Quote size={22} className="text-[#C98C97]" strokeWidth={1.2} />
              <blockquote className="font-serif-display text-2xl leading-snug text-[#2D3640] italic">"{tt.text}"</blockquote>
              <figcaption className="mt-auto font-script text-xl text-[#5E7891]">{tt.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
